module.exports = __webpack_public_path__ + "assets/images/intro-bg-4_5cffa93db0b76729b205222c77ee112b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/intro/intro-bg-4.png
// module id = 61
// module chunks = 0